const replacementTrait = {
    /**
     * return mode display for given data
     * @param {object} item
     * @param {string} equipment
     * @param {object} modes
     * @param {[object]} modeReplacements
     * @returns {string}
     */
    modeDisplay: function(item, equipment, modes, modeReplacements)
    {
        let isMachinery = equipment === 'machinery';
        let displayModes = [];
        let surveyTypes = (item.surveyType || '').split(',');
        let repairCodes = (item.repairCode || '').split(',');

        // process mode replacements
        let overriddenSurveyTypes = [];
        surveyTypes.forEach(surveyType => {
            repairCodes.forEach(repairCode => {
                modeReplacements.forEach(replacement => {
                    if (
                        equipment === replacement.equipment
                        && replacement.surveyTypes.includes(parseInt(surveyType))
                        && replacement.viewTypes.includes(parseInt(item.viewType))
                        && replacement.componentCodes.includes(item.componentCode)
                        && replacement.repairCodes.includes(repairCode)
                    ) {
                        displayModes.push(replacement.modeReplacement);
                        overriddenSurveyTypes.push(surveyType);
                    }
                });
            });
        });

        // process normal mode display
        let modeKey = surveyTypes.filter(surveyType => !overriddenSurveyTypes.includes(surveyType));
        if (isMachinery) {
            modeKey = (item.serviceType || '').split(',');
        }
        modeKey.forEach(key => {
            if (modes[key]) {
                displayModes.push(modes[key]);
            }
        });

        // removes duplicates
        return displayModes.filter((element, index) => {
            return displayModes.indexOf(element) === index;
        }).join(', ');
    }
};

export default replacementTrait;